// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"8ced7ca1","374":"d726edad","976":"197b0daa"}[chunkId] + ".chunk.js";
};